<template>
	<div class="columns">
		<div class="column is-6 text-center-mobile">
			<img src="/front/img/circle-bg.svg" class="circle-img" :alt="this.locale == 'en' ? 'Tam' : 'تم' "/>
			<div class="mob-bg">
				<div class="mob-mask">
					<iframe title="video title" v-if="landing" width="300" height="600" :src="activeVideo" frameborder="0" allow="encrypted-media" allowfullscreen>
					</iframe>
					<img v-else src="/front/img/footer_img.png"  :alt="this.locale == 'en' ? 'Tam' : 'تم' ">
				</div>
			</div>
		</div>
		<div class="column is-6 text-center-mobile">
			<p class="has-text-primary has-text-weight-bold is-size-5 mb20">
				<template v-if="landing"> {{ this.locale == 'en' ? 'How To Use App ?' : 'كيف تستخدم التطبيق ؟'}}</template>
				<template v-else> {{ this.locale == 'en' ? 'Download App Now' : 'حمل التطبيق الان'}}</template>
			</p>
			<p v-if="!landing" class="has-text-primary">
				{{ appsHint }}
			</p>
			<ul v-if="landing">
				<li v-for= "video , index in videos">
					<a rel="noreferrer" :href="video.link" class="has-text-grey has-text-weight-bold hvr-arrow pr20" :class="{'is-active':index == selected}"  @click.prevent="changeVideo(video,index);">
						{{video.title}}
					</a>
				</li>
			</ul>
			<div class="apps-container mt30">
				<a rel="noreferrer" :href="androidLink" class="hvr-grow" :class="[landing ==true ? 'is-inline-block' : 'is-block']">
					<img class="height-60" src="/front/img/google.png" :alt="this.locale == 'en' ? 'Tam' : 'تم'">
				</a>
				<a rel="noreferrer" :href="iosLink" class="hvr-grow" :class="[landing ==true ? 'is-inline-block' : 'is-block']">
					<img class="height-60" src="/front/img/iphone.png" :alt="this.locale == 'en' ? 'Tam' : 'تم' ">
				</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Usage',
		props: {
			landing: {
				type: Boolean,
				required: true
			},
            items: {
                type: Array,
                required: false
            },
            locale: {
                type: String,
                required: true
            },
            iosLink: {
                type: String,
                required: true
            },
            androidLink: {
                type: String,
                required: true
            },
            appsHint: {
                type: String,
                required: false
            },
		},
		data(){
			return{
				videos:[],
				activeVideo:null,
				selected:0
			}
		},
		created(){
		    this.videos = this.items;
			let el = this;
			 window.addEventListener("load", function(event) {
				el.activeVideo = el.videos[0].link;
			});
		},
		methods:{
			changeVideo(video,index){
				this.selected = index;
				this.activeVideo = video.link;
			}
		}

	};
</script>

<style lang="scss">

</style>


